
<!--&lt;!&ndash; Submit and Download Buttons &ndash;&gt;-->

<section #content id="previewChildCaseStudyReports" class="mt-4">
  <div class="d-flex justify-content-end">
    <button mat-raised-button color="warn" class="m-2 col-md-2" (click)="cancel()">Cancel</button>
  </div>
  <h2 style="text-align: center">Highlight Report</h2>
  <div class="d-flex justify-content-center gap-4" id="print-section">
    <!-- Report Data Section -->
    <table  class="m-3" style="width: 100%; border-collapse: collapse;">
      <h3 style="text-align: left; font-weight: bold; font-size: 20px; margin-bottom: 15px;">
        Center Name: {{ highligtData.centreCode}}
      </h3>
      <table style="width: 100%; border-collapse: collapse;">
        <tbody>

        <tr>
          <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Center Name</th>
          <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{ highligtData.centreCode }}</td>
        </tr>

        <tr>
          <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Highlight</th>
          <td style="padding: 8px; border-bottom: 1px solid #ddd;" colspan="2">
            {{ getJoinedHighlights() }}
          </td>
        </tr>

        <tr>
          <th style="text-align: left; padding: 8px; border-bottom: 1px solid #ddd;">Event Date</th>
          <td style="padding: 8px; border-bottom: 1px solid #ddd;">{{highligtData.eventDate.toDate() | date}}</td>
        </tr>
        </tbody>
      </table>
    </table>
    <!-- Narrative Text Section -->
  </div>
</section>
<div *ngIf="highligtData.highlights?.length ==1">
  <h3>Remark</h3>
  <div style="display: flex; justify-content: center; margin-top: 16px;">
    <p style="text-align: justify; text-justify: inter-word; padding: 10px" [innerHTML]="highligtData.narrative">
      {{narrative }}
    </p>
  </div>
</div>

<div *ngIf="highligtData.highlights?.length >1">
  <h3 style="text-align: center; margin-top: 30px;">Detailed Highlights</h3>
  <table style="width: 100%; border-collapse: collapse; margin-top: 20px;" *ngIf="highligtData.highlights?.length >1 ">
    <thead>
    <tr style="background-color: #f2f2f2;">
      <th style="border: 1px solid #ddd; padding: 8px;">Sr.No</th>
      <th style="border: 1px solid #ddd; padding: 8px;">Highlight</th>
      <th style="border: 1px solid #ddd; padding: 8px;">Narrative</th>
      <th style="border: 1px solid #ddd; padding: 8px;">Event Date</th>
      <th style="border: 1px solid #ddd; padding: 8px;">Added By</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let h of highligtData.highlights; let i = index">
      <td style="border: 1px solid #ddd; padding: 8px;">{{ i + 1 }}</td>
      <td style="border: 1px solid #ddd; padding: 8px;">{{ h.highlight }}</td>
      <td style="border: 1px solid #ddd; padding: 8px;" [innerHTML]="h.narrative || 'No narrative provided.'"></td>
      <td style="border: 1px solid #ddd; padding: 8px;">
        {{ h.eventDate?.seconds * 1000 | date: 'mediumDate' }}
      </td>
      <td style="border: 1px solid #ddd; padding: 8px;">{{ h.addedBy }}</td>
    </tr>
    </tbody>
  </table>
</div>
